// extracted by mini-css-extract-plugin
var _1 = "CourseSidebarLayout_container__5b6bd";
var _2 = "CourseSidebarLayout_fluid__76519";
var _3 = "CourseSidebarLayout_positionRight__58e90";
var _4 = "CourseSidebarLayout_root__4284b";
export { _1 as "container", _2 as "fluid", _3 as "positionRight", _4 as "root" }
